import { Box, Typography } from "@mui/material";
import { Account } from "Components/Shared/Account/Account";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

type Props = { account: BankAccountListItem };

export const PromptWithAccountInfo = ({ account }: Props) => {
  const { t } = useResource();

  return (
    <>
      <Typography>
        {t(Resources.Pages.Content.BankAccounts.DeleteAccount.Prompt)}
      </Typography>
      <Box
        sx={({ spacing, palette }) => ({
          p: spacing(2, 4),
          borderRadius: spacing(2),
          border: `1px solid ${palette.grey[300]}`,
        })}
      >
        <Account {...account} />
      </Box>
    </>
  );
};
